module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAS5JREFUOBGtlE0OAUEQhUVCLCwssHAYx8De1gXs3MsdrLiC2DiAhIzvjeqka/RMt0Qlle6q96Ome0av14iqqsbkjjySV/Jhq2r1xw1Jewl5Rd7IrhC+ancxBNI+cjmx35ALcmiravVD7FtNYWgyxZM8kIMUWX3DxVN8T0pTZxYe85Ayavbg60cV0vkzpaGDVuhxkpMlDDVpePydwwF0e4qNAzKF+LUKvaPS1KuhWDggU4hfq9A7Kk29Z4qhAzKF+LUKfUztU9ytMY2Bgn3gB30tkeHFxMsCk5gS+EH/wRj777f83/dQczLlr1/Kyy5kG5+B20P49VuW55mcOaO4ACz9t9maGUveVGeqi+r8PwSfmRlLxjSeumufMJ108YswTOc2IUu1LhLlSBhNZEaO3pNWQmIvrI9tAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon--magnify.png
// module id = Rq7U
// module chunks = 1